module.exports = __webpack_public_path__ + "static/media/wheel-balancing-red.79a6c751.svg";